import { atom } from "recoil";


const PagePathAtom = atom({
    default: 'ds',
    key: 'IdPage'
})

export default PagePathAtom;